import { i18n } from "../../domain/i18n.js";
import { AbText } from "../../widgets/text/text.widget.js";
import {AbCroppedText} from "../../widgets/cropped-text/cropped-text.widget.js";
import { AbButton } from '../../widgets/button/button.widget.js';
import { goToLink } from '../../utils/browser-utils.js';

/**
 * @typedef {RenderableProps} _AbBadgeTexts_Props
 * @property {_Company} company
 * @property {_BrandPartner[]} brands
 * @property {'minimal'|'full'|'brand-link'} textType
 * @property {'only-authby'|'only-brandCount'} [textTypeMinimalOption]
 * @property {boolean} [center = false]
 * @property {string} [certificateUrl]
 * @property {string} [t0]
 */
export function AbHeaderBadgeTexts({ brands, center, company, textType, textTypeMinimalOption, certificateUrl, t0 }) {
  return (
    <div className={`ab-badge-texts ${center ? 'ab-center' : ''}`}>
      {(textType === 'minimal') &&
        <div>
          {(!textTypeMinimalOption || (textTypeMinimalOption === 'only-authby')) &&
            <div>
              <AbText text={i18n.generic.authorizedBy} emphasis={true} />
            </div>
          }
          {(!textTypeMinimalOption || (textTypeMinimalOption === 'only-brandCount')) &&
            <div>
              <AbText text={i18n.generic.brands} params={{ count: brands.length }} counts={{ brands: brands.length }} emphasis={true} />
            </div>
          }
        </div>
      }
      {textType === 'full' &&
        <div>
          <div>
            <AbText text={i18n.header.texts.full.isAuthorized1} params={{
              url: <AbCroppedText maxChars={30} text={company.homepageBare} emphasis />
            }}/>
          </div>
          <div>
            {!t0 && <AbText text={i18n.header.texts.full.isAuthorized2} />}
            {(t0 === 'no-account' || t0 === 'not-approved') && <AbText text={i18n.header.texts.full.isAuthorized2_t0NotApproved} />}
            {(t0 === 'no-brands') && <AbText text={i18n.header.texts.full.isAuthorized2_t0NoBrands} />}
          </div>
          <div>
            {!t0 && <AbText text={i18n.header.texts.full.isAuthorized3} params={{
              brands: <AbText text={i18n.header.texts.full.brands} params={{ count: brands.length }} counts={{ brands: brands.length }} emphasis={true} />
            }}/>}
          </div>
        </div>
      }
      {(textType === 'brand-link') &&
      <div>
        <div>
          <AbText text={i18n.generic.authorizedBy} emphasis={true} />
        </div>
        <div>
          <AbButton type="link" href={certificateUrl}>
            <AbText
              text={brands.length > 2 ? i18n.header.texts.brandLink.multiple : brands.length > 1 ? i18n.header.texts.brandLink.two : i18n.header.texts.brandLink.one}
              params={{ brandName: brands[0].displayName, count: brands.length - 1 }}
              emphasis={true} />
          </AbButton>
        </div>
      </div>
      }
    </div>
  );
}
